import React, { Component } from 'react'

class Filtro extends Component {
  constructor (props) {
    super(props);
    this.state = { exibirFiltro: false };
    this.alterarExibicaoFiltro = this.alterarExibicaoFiltro.bind(this)
  }

  alterarExibicaoFiltro () {
    this.setState({ exibirFiltro: !this.state.exibirFiltro })
  }

  render () {
    const { exibirFiltro } = this.state;
    return (
      <React.Fragment>
        <div className="col-10"/>
        <span className="input-group-append">
          <button id="btn-filtro"
                  className={`vx-gp-filter-btn${exibirFiltro ? ' vx-gp-filter-btn--active' : ''}`}
                  type="button" onClick={this.alterarExibicaoFiltro}>
            <span className="material-icons">tune</span>
            Filtros
          </button>
        </span>

        <div className={`vx-filter-panel-overlay${exibirFiltro ? ' aberto' : ''}`}
             onClick={this.alterarExibicaoFiltro}/>

        <div className={`vx-filter-panel${exibirFiltro ? ' aberto' : ''}`}>
          <div className="vx-filter-panel-header">
            <div className="vx-filter-panel-title">
              <span className="material-icons">tune</span>
              Filtros
            </div>
            <button type="button" className="vx-modal-close" onClick={this.alterarExibicaoFiltro}>
              <span className="material-icons">close</span>
            </button>
          </div>
          <div className="vx-filter-panel-body">
            <this.props.PainelFiltro/>
          </div>
          <div className="vx-filter-panel-footer">
            <button type="button" className="vx-modal-btn-confirmar" style={{width: '100%'}}
                    onClick={this.alterarExibicaoFiltro}>
              <span className="material-icons">check</span>
              Aplicar e Fechar
            </button>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

export default (Filtro)
